import { schema } from 'normalizr';

const boostSchema = new schema.Entity('boosts', {});

export default boostSchema;
